import { Tooltip, TooltipProps } from 'antd';
import React from 'react';

type ConditionalTooltipProps = {
  show: boolean;
  title: React.ReactNode;
  children: React.ReactNode;
} & Omit<TooltipProps, 'title' | 'children'>;

export default function ConditionalTooltip({
  show,
  title,
  children,
  ...rest
}: ConditionalTooltipProps) {
  return show ? (
    <Tooltip title={title} destroyOnHidden {...rest}>
      <span style={{ display: 'inline-block' }}>{children}</span>
    </Tooltip>
  ) : (
    <>{children}</>
  );
}
